<template>
  <v-card class="secondarybackground" height="200" style="overflow-y: auto;">
    <v-card-text class="caption">
      <div class="font-weight-bold subtitle-2 ml-5 font-italic">
        {{ item.equipment_type }}
      </div>
      <div>
        <span class="font-weight-bold">Matériel :</span>
        {{ item.equipment }}
      </div>
      <div>
        <span class="font-weight-bold">Marque :</span>
        {{ item.brand_name }}
      </div>
      <div>
        <span class="font-weight-bold">Référence :</span>
        {{ item.model }}
      </div>
      <div>
        <span class="font-weight-bold">Nombre :</span>
        {{ item.number_of_equipment }}
      </div>
      <div>
        <span class="font-weight-bold">Dimension :</span>

        {{
          item.sizing_value &&
            item.sizing_unit &&
            `${item.sizing_value} ${item.sizing_unit}`
        }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'P3InventoryCard',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
